<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span> {{ $t('company.users') }} </span></li>
				</ul>
			</div>
		</div>

		<div id="users_toolbar" class="toolbar">
			<button id="users_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
			<button id="users_table_toolbar_remove" :title="$t('delete')">
				<span uk-icon="trash"></span>
				<span class="title">{{ $t('delete') }}</span>
			</button>
			<button id="users_table_toolbar_enable" :title="$t('confirm')">
				<span uk-icon="check"></span>
				<span class="title">{{ $t('confirm') }}</span>
			</button>
			<button id="users_table_toolbar_disable" :title="$t('disable')">
				<span uk-icon="close"></span>
				<span class="title">{{ $t('disable') }}</span>
			</button>
			<button id="users_table_toolbar_set_group" :title="$t('group')">
				<span uk-icon="users"></span>
				<span class="title">{{ $t('group') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit.user') }}</a></li>
				<li><a tabindex="-1">{{ $t('remove.user') }}</a></li>
				<li><a tabindex="-1">{{ $t('confirmed.user') }}</a></li>
				<li><a tabindex="-1">{{ $t('disable.user') }}</a></li>
			</ul>
		</div>

		<UserCreateModal v-if="isVisibleModal" @close-modal="closeModal"/>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { UserManager } from '@/core/administration/UserManager'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'
import UserCreateModal from 'components/modal/UserCreateModal'

export default {
	name: 'CompanyUsers',
	metaInfo: {
		title: 'Company users'
	},
	components: {
		UserCreateModal
	},
	data () {
		return {
			isVisibleModal: false
		}
	},
	props: [
		'id',
		'admin'
	],
	mounted () {
		let vm = this
		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'first.name',
				'columnName': 'firstName',
				'attribute': 'person_firstName'
			},
			{
				'title': 'last.name',
				'columnName': 'lastName',
				'attribute': 'person_lastName'
			},
			{
				'title': 'user.login',
				'columnName': 'login',
				'attribute': 'person_login'
			},
			{
				'title': 'description',
				'columnName': 'description',
				'attribute': 'person_description'
			},
			{
				'title': 'group',
				'columnName': 'groupName',
				'attribute': 'group_name'
			},
			{
				'title': 'role',
				'columnName': 'role',
				'attribute': 'group_role'
			},
			{
				'title': 'confirmed',
				'columnName': 'active',
				'attribute': ''
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' }
		}

		let companyId = this.id || this.$store.getters.getProfile.companyId

		window.manager = new UserManager(this)
		manager.setProperties({ companyId: companyId })

		this.$store.dispatch(USER_CONFIG, 'usersTable.tableState')
			.then((config) => {
				window.table = new Table('usersTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						frozenFirstColumn: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								initUserManager('edit', {
									id: item.id,
									companyId: item.companyId,
									individualPersonId: item.individualPersonId,
									groupId: item.groupId
								}, attribute)
							},
							2: function (item, attribute) {
								manager.initRemoveUserManager({
									id: item.id,
									companyId: item.companyId,
									active: false
								}, attribute)
							},
							3: function (item) {
								managerEnabledUser(true, item.id)
							},
							4: function (item) {
								managerEnabledUser(false, item.id)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								initUserManager('edit', {
									id: item.id,
									companyId: item.companyId,
									individualPersonId: item.individualPersonId,
									groupId: item.groupId
								}, table.selectedAttribute)
							}
						}
					},
					function (data) {
						$.each(data, function (index, value) {
							data[index].active = value.active ? '<i class="fa fa-check success" aria-hidden="true"/> ' + getLocalizedMessage('confirmed') :
								'<i class="fa fa-times danger" aria-hidden="true"/> ' + getLocalizedMessage('unconfirmed')
						})
					}
				)
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + 'company/' + companyId + '/users/load')
				table.setDataIDsUrl(window.urlContext + 'company/' + companyId + '/users/ids')
				table.setDataSortUrl(window.urlContext + 'company/' + companyId + '/users/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG usersTable', error)
			})



		// toolbar buttons
		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#users_table_toolbar_add').click(function () {
			initUserManager('create', -1, '')
		})
		$('#users_table_toolbar_remove').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert('no.selected.users', 'warning')
			} else {
				manager.initRemoveUsersManager(ids)
			}
		})
		$('#users_table_toolbar_enable').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert('no.selected.users', 'warning')
			} else {
				managerEnabledUser(true, ids.join())
			}
		})
		$('#users_table_toolbar_disable').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert('no.selected.users', 'warning')
			} else {
				managerEnabledUser(false, ids.join())
			}
		})
		$('#users_table_toolbar_set_group').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert('no.selected.users', 'warning')
			} else {
				manager.loadAndSetUserGroups()
				manager.groupingUsers(ids, function () {
					table.initTable()
				})
			}
		})

		function initUserManager (action, user, activeAttribute) {
			if (action === 'create') {
				$.ajax({
					type: 'POST',
					url: window.urlContext + 'persons/' + companyId,
					success: function (individualPersons) {
						setUserManagerProperties(action, activeAttribute, user, individualPersons)
					}
				})
			} else {
				$.ajax({
					type: 'POST',
					url: window.urlContext + 'user/get',
					data: {id: user.id },
					contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
					success: function (individualPersons) {
						setUserManagerProperties(action, activeAttribute, user, individualPersons)
					}
				})
			}
			manager.loadAndSetUserGroups()
		}

		function managerEnabledUser (status, id) {
			$.ajax({
				type: 'POST',
				url: window.urlContext + 'users/activate',
				data: 'ids=[' + id + ']&status=' + status,
				success: function (res) {
					location.reload()
				}
			})
		}

		function setUserManagerProperties (action, activeAttribute, user, individualPersons) {
			manager.setProperties({
				action: action,
				activeAttribute: activeAttribute,
				user: user,
				companyId: companyId,
				individualPersons: individualPersons || [],
				postSaveAction: function () {
					table.initTable()
				}
			})

			vm.isVisibleModal = true
		}

		$(window).resize(function() {
			resizeTableHeight();
			table.frozenTableElements.setFrozenHeaderCellsWidth();
			table.frozenTableElements.setFrozenColumnCellsHeight();
		});

	},
	methods: {
		closeModal: function () {
			this.isVisibleModal = false
		}
	}
}
</script>

<style scoped>

</style>
